import { render, staticRenderFns } from "./TutorialStart.vue?vue&type=template&id=31f88a24&"
import script from "./TutorialStart.vue?vue&type=script&lang=js&"
export * from "./TutorialStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports